import React from "react";

import './About.css';

export default function About() {
    return (
        <div id="about">
            <div className="terminal-header">
                <span className="dot close-dot"></span>
                <span className="dot min-dot"></span>
                <span className="dot max-dot"></span>
                <span className="terminal-title">Terminal.exe</span>
            </div>
            <div className="terminal-body">
                <div className="profile-pic">
                    <div className="profile-photo" src="/pixel.png" alt="Profile"/>
                </div>
                <div className="about-text">
                    <h1>About</h1>
                    <p>Hello! My name is <b>Andrew</b> and I'm an <b>IT Engineer</b>/<b>Software Developer</b> with 5+ years of experience in the IT industry. I have a passion for technology, computing infastructure, and web development. 
                    I love to create tools to help connect people, make their lives easier, and enable them to do cool things! I'm a filthy casual gamer when I find the time to play them, a caffeine junkie, and a certified triple treat: 
                    Nerd, Geek, and a Dork!</p>
                    <p>B.S. Computer Engineering - California Polytechnic State University, San Luis Obispo</p>
                    <p>{">"}<span className="cursor"/></p>
                </div>
            </div>
        </div>
    );
}